// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36No3","field":"styles_field__oQRdU","fieldCol":"styles_fieldCol__jQZuC","diffCol":"styles_diffCol__2MmD2","diff":"styles_diff__3RNnr"};